import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { IhmTimeFieldComponent } from './ihm-time-field.component';

@NgModule({
  imports: [CommonModule, MatIconModule, MatSelectModule, FormsModule, ReactiveFormsModule],
  declarations: [IhmTimeFieldComponent],
  exports: [IhmTimeFieldComponent]
})
export class IhmTimeFieldModule {}
